export default "__VITE_ASSET__B$dLkVqg__"